<script>
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import * as globalEnum from "src/common/global-enum";
import * as utils from "src/store/utils";
import {
  parseImgUrl,
  setImgStyle,
  parseImgUrlProductImg
} from "src/filter/modules/img";
@Component({
  name: "estimated-cost-picture",
  components: {}
})
export default class App extends Vue {
  @Prop({ type: Object, default: () => ({}) }) info;

  imgInfo = {
    class: null,
    url: null
  };
  mounted() {
    this.imgInfo = setImgStyle(this.info.imgUrl);
  }
  render(h) {
    function setRateStyle(info) {
      if (info > 5.5) {
        return {
          backgroundColor: "white",
          color: "#333"
        };
      } else {
        return {
          backgroundColor: "#FF9999 !important",
          color: "white"
        };
      }
    }
    return (
      <div class="estimated-cost-picture">
        <div class="estimated-cost-picture__head__headMain">
          <div class="left">
            {this.info.productCategory}
            <br /> - <br />
            {this.info.s032}
            <br /> - <br />
            {this.info.s077}
          </div>
          <div class="main">
            <img src={this.imgInfo.url} class={this.imgInfo.class} />
          </div>
          <div class="right">
            {(!this.info.checkFlag || this.info.checkFlag === 0) && '未审核' }
          </div>
        </div>
        <div class="estimated-cost-picture__row bottom">
          <div>{this.info.materialCode}</div>
          <div>{this.info.tagPrice}</div>
          <div>{this.info.demandQuantity}</div>
        </div>
        <div class="estimated-cost-picture__row">
          <div>{this.info.yearPeriod}</div>
          <div>{this.info.waveCode}</div>
          <div>{this.info.vendorName}</div>
        </div>
        <div class="estimated-cost-picture__row">
          <div>{this.info.costRate}</div>
          <div></div>
          <div>{this.info.rate}</div>
        </div>
        <div class="estimated-cost-picture__row">
          <div>{this.info.masterCode}</div>
          <div>{this.info.ingredient}</div>
          <div>{this.info.masterPrice}</div>
        </div>
        <div class="estimated-cost-picture__row height bottom">
          <div>{this.info.masterDesc}</div>
          <div>{this.info.wide}</div>
          <div>{this.info.dosage}</div>
        </div>
        <div class="estimated-cost-picture__row">{this.info.costStructure}</div>
        <div class="estimated-cost-picture__row">{this.info.diffName}</div>
        <div class="estimated-cost-picture__row">{this.info.diffPrice}/{this.info.furAccessoryRemark}</div>
        <div class="estimated-cost-picture__row height bottom estimated-cost-picture__row__last">
          <p>{this.info.remark}</p>
          <p>{globalEnum.followFlagPlannCost_Show[this.info.followFlag]}</p>
        </div>
      </div>
    );
  }
}
</script>

<style lang="scss" scope>
.estimated-cost-picture {
  border: 1px solid #333;
  width: 340px;
  height: 500px;
  overflow: hidden;
  & > .estimated-cost-picture__head {
    text-align: center;
    height: 25px;
  }

  .estimated-cost-picture__row__last {
    flex: 1;
    & > div {
      width: 50% !important;
    }
    & > div:nth-child(2) {
      text-align: right;
    }
  }
  & > .estimated-cost-picture__head__headMain {
    & > div {
      -webkit-print-color-adjust: exact;
    }
    padding-bottom: 10px;
    height: 250px;
    display: flex;
    & > .left {
      width: 20px;
      margin-left: 15px;
    }
    & > .main {
      width: 70%;
      overflow: hidden;
      text-align: center;
    }
    .vendor-name-box {
      width: 56px;
      .right {
        width: 20px;
        height: 55px;
        margin-left: 15px;
        color: red;
      }
      .vendorName {
        width: 56px;
        height: 200px;
        margin-top: 2px;
        text-align: center;
      }
    }
    img {
      width: 100%;
      height: 100%;
    }
  }

  & > .estimated-cost-picture__row {
    & > div {
      -webkit-print-color-adjust: exact;
    }
    &.bottom {
      border-bottom: 1px solid #999;
    }
    &.height {
      height: 50px;
    }
    height: 25px;
    display: flex;
    padding: 0 15px;
    & > div:nth-child(1) {
      width: calc(2 / 5 * 100%);
    }
    & > div:nth-child(2) {
      width: calc(2 / 5 * 100%);
    }
    & > div:nth-child(3) {
      width: calc(1 / 5 * 100%);
    }
    & > span {
      display: inline-block;
      overflow: hidden;
      width: 50%;
    }
    & > p:nth-child(1) {
      display: inline-block;
      width: 80%;
    }
    & > p:nth-child(2) {
      display: inline-block;
      width: 20%;
    }
  }
}
</style>